import $ from 'jquery';

const header = document.querySelector('.header');
const navMenu = $('.nav');
const hamburger = $('.hamburger');
const navMenuList = $('.navMenu__list');
const toggleSubMenuBtns = document.querySelectorAll('.navMenu__toggleSubMenu');

hamburger.on('click', function() {
    navMenu.toggle();
    hamburger.toggleClass('is-active');
    navMenuList.slideToggle();
});


// Change header class on scroll
let initScrollPos = document.documentElement.scrollTop;
if (initScrollPos > 100) {
    header.classList.add('has-light-mode');
}

if (header && !header.classList.contains('no-top-banner')) {
    window.addEventListener('scroll', () => {
        let scrollPos = window.scrollY;
        if (scrollPos > 100) {
            header.classList.add('has-light-mode');
        } else {
            header.classList.remove('has-light-mode');
        }
    });
}

Array.from(toggleSubMenuBtns).forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.parentElement.nextElementSibling.classList.toggle('is-visible');
    });
});
